/**
 * 主流程相关接口
 */

const main = {
  /**
   * 协议留痕
   */
  apiAgreeProtocol: ['/lt-web/protocol/consent/agree'],
  getConfigTemplateContent: ['/lt-web/h5/config/templateContent'], // 获取新版协议模版详情接口
  getH5pageConfig: ['/lt-web/h5/config/getPageConfig'], // 获取动态页面配置
  getH5pageFields: ['/lt-web/borrow/getProcotolInfo'], // 获取动态填充字段
  getThirdProtocol: ['/lt-web/third/entrance/borrow/getProtocol'], // api三方获取借款合同
  /**
   * 多账号切换
   */
  sendChangeAccountSms: ['/lt-web/xs/app/act/sendChangeAccountSms'], // 发送切换账号短信验证码
  submitChangeAccount: ['/lt-web/xs/app/act/changeAccount'], // 确认切换账号
  /**
   * 认证模块
   */
  checkIdcard: ['/lt-web/xs/app/check/idcard'], // 校验身份证号
  getAuthSupplier: ['/lt-web/xs/userAuth/userAuthSupplier'], // 获取用户认证路由服务商
  getIsMulPhones: ['/lt-web/xs/app/act/isMulPhones'], // 判断是否是多号账号
  submitOcrRealName: ['/lt-web/xs/userAuth/ocrRealName'], // 实名认证提交
  submitFaceRecognition: ['/lt-web/xs/userAuth/faceRecognition'], // 人脸认证提交
  getUserInfo: ['/lt-web/xs/user/getUserInfo'], // 获取用户信息
  getPhoneUid: ['/lt-web/xs/user/getPhoneUid'], // 获取当前用户UID
  // getUserPushStatus: ['/lt-web/xs/user/getUserPushStatus'], // 获取用户实名认证&一推状态信息
  getGoBorrowPage: ['/lt-web/xs/borrow/goBorrowPage'], // 一推授信成功页面，立即借款接口
  apiIsAuthorizeList: ['/lt-web/xs/userAuth/checkContracts'], // 判断是否需要获取通讯录/短信/通话记录/位置（实时）
  getRealNameAuthentication: ['/lt-web/xs/userAuth/realNameAuthentication'], // 获取一推被拒页信息
  getRefusePageInfo: ['/lt-web/xs/userAuth/realNameAuth/result/banner'], // 获取一推被拒页信息
  getCreditResult: ['/lt-web/xs/userAuth/getCreditResult'], // 获取授信结果
  getAssistedUserStatus: ['/lt-web/assisted/full-h5/user/status'], // 获取用户状态：oldUser老用户
  getAssistedLogin: ['/lt-web/assisted/full-h5/union-login/page'], // 获取联登页面地址
  /**
   * 绑卡模块
   */
  apiCheckBankCard: ['/lt-web/xs/userAuth/checkBankCard'], // 校验银行卡
  apiOtherBindingCardList: ['/lt-web/xs/userAuth/otherBindingCardList'], // 获取历史绑定银行卡列表
  apiGetListBankCardNumber: ['/lt-web/xs/userAuth/optionalListBankCardNumber'], // 获取所属银行卡列表
  apiSmsVerification: ['/lt-web/xs/userAuth/smsVerification'], // 发送短信验证码
  apiCheckSmsVerification: ['/lt-web/xs/userAuth/checkSmsVerification'], // 提交绑卡
  apiQueryBindResult: ['/lt-web/xs/userAuth/queryBindResult'], // 长银资方绑卡的时候需要轮训查询结果
  apiChangeMainCard: ['/lt-web/xs/userAuth/changeMainCard'], // 改变主副号
  getRepayBindBankList: ['/lt-web/xs/repay/bindingBankList'], // 获取还款银行列表
  /**
   * 还款模块
   */
  getInCreditBorrowList: ['/lt-web/xs/borrow/getInCreditBorrowList'], // 获取多笔未还借款列表
  getIsShowBillList: ['/lt-web/xs/borrow/isShowBillList'], // 是否展示单笔账单列表
  getOneBorrowRepayList: ['/lt-web/xs/repay/getNotRepayList'], // 获取单笔未还账单列表
  getConsuAmountNotRepayList: ['/lt-web/xs/repay/getConsuAmountNotRepayList'], // 获取债务咨询费未还列表
  getIsAdanceRepay: ['/lt-web/xs/borrow/isAdvanceRepay'], // 是否可以提前结清
  getNeedPayConsuAmount: ['/lt-web/xs/repay/getNeedPayConsuAmount'], // 获取贷后服务费未还金额
  sendRepaymentSms: ['/lt-web/xs/repay/sendRepaymentSms'], // 发送还款短信验证码接口
  submitPayRepayment: ['/lt-web/xs/repay/payRepayment'], // 还款支付提交
  apiGuaranteeFeeQuote: ['/lt-web/xs/repay/guaranteeFeeQuote'], // 服务端按还款账单范围匹配原期担保费
  getBorrowList: ['/lt-web/xs/borrow/getBorrowList'], // 获取借款记录列表
  getRepayList: ['/lt-web/xs/repay/getRepayList'], // 获取还款记录列表
  getRepayDetailList: ['/lt-web/xs/repay/getRepayDetailList'], // 获取还款流水明细
  getTransInfo: ['/lt-web/borrow/getTransInfo'], // 获取债转相关信息
  getNeedPayBorrowList: ['/lt-web/xs/repay/getNeedPayBorrowList'], // 获取提前结清试算账单
  getBorrowDetailList: ['/lt-web/xs/borrow/getBorrowDetailList'], // 获取贷款详情
  getBorrowBillDetail: ['/lt-web/xs/borrow/getBorrowBillDetail'], // 获取贷款账单详情
  getConsuAmountRepayList: ['/lt-web/xs/repay/getConsuAmountRepayList'], // 获取债务咨询费未还列表
  getFinanceReport: ['/lt-web/xs/user/getGuaranteeReport'], // 获取融资咨询服务报告
  getRepayPlan: ['/lt-web/xs/repay/getRepayPlan'], // 获取还款计划
  // 棉图报告相关
  canShowMiantuContract: ['/lt-web/miantu/report/canShow'], // 判断是否展示债务咨询合同入口
  getMaintuContractUrl: ['/lt-web/miantu/report/link'], // 获取债务咨询合同地址
  reviewContractNotify: ['/lt-web/yhh/openProtocol/notify'], // 查看合同
  submitApplyClearance: ['/lt-web/xs/borrow/xsSettleCrtApply'], // 申请结清证明
  preCheckApplyClearance: ['/lt-web/xs/borrow/xsSettleCrtApplyPreCheck'], // 申请结清证明前置检查
  /**
   * 借款申请模块
   */
  // 锡锡贷24+权益相关
  apiXxdHaveBorrow: ['/lt-web/borrow/xsH5/isHaveXsH5Borrow'], // 判断是否有借款
  apiXxdFirstEnjoyCheckCardBind: ['/lt-web/member/h5/checkCardBind'], // 获取用户绑卡状态
  apiXxdFirstEnjoySendSms: ['/lt-web/member/h5/sendSms'], // 发送短信验证码
  apiXxdFirstEnjoyVerify: ['/lt-web/member/h5/verify'], // 校验绑卡验证码
  apiXxdBorrowAfterPayBanner: ['/lt-web/borrow/xsH5/afterPay/banner'], // 获取锡锡贷借款结果页先享后付配置
  apiXxdBorrowBanner: ['/lt-web/borrow/xsH5/baseMember/banner'], // 获取锡锡贷借款结果页banner
  // 借款结果页
  apiBorrowConfirmAllBanner: ['/lt-web/borrow/borrowConfirm/all/banner'], // 获取借款结果页先享后付配置
  getThirdRejectBorrow: ['/lt-web/xs/borrow/getThirdRejectBorrow'], // api渠道 - 获取拒绝原因及回调地址
  // 申请借款页面
  getApplyBorrowInfo: ['/lt-web/xs/borrow/getApplyBorrowInfo'], // 获取页面数据
  getBorrowAmountInfo: ['/lt-web/xs/borrow/getBorrowAmountInfo'], // 借款金额计算
  getBorrowInfoOnce: ['/lt-web/xs/borrow/getFirstApplyInfo'], // 获取模式和先享后付状态
  borrowTargetUser: ['/lt-web/xs/borrow/target/user'], // 判断是否为目标用户
  borrowRateType: ['/lt-web/xs/borrow/rate/type'], // 利率列表
  borrowTargetUserCard: ['/lt-web/xs/borrow/target/user/card'], // 获取助贷卡的金额和图片
  getBorrowPage: ['/lt-web/xs/app/getApplyBorrowPage'], // 申请借款页弹窗
  chooseCard: ['/lt-web/xs/userAuth/chooseCard'], // 选择在联通已绑卡进行绑定
  // 借款确认页
  sendBorrowSms: ['/lt-web/xs/borrow/sendBorrowSms'], // 发送借款短信验证码
  submitBorrowPay: ['/lt-web/xs/borrow/borrowPay'], // 借款申请提交
  /**
   * 注销模块
   */
  getUserRealInfo: ['/lt-web/user/getUserRealInfo'], // 获取用户信息
  apiPreCloseAccount: ['/lt-web/h5/user/preCloseAccount'], // 是否符合注销账号要求
  sendCASmsCode: ['/lt-web/h5/sendCASmsCode'], // 注销发送验证码
  closeAccount: ['/lt-web/h5/user/closeAccount'], // 注销账户
  /**
   * 其他模块
   */
  getOcrPage: ['/lt-web/xs/app/getOCRPage'], // 获取ocr页面弹窗
  getFaqList: ['/lt-web/xs/user/getFaqContent'], // 获取常见问题列表
  getCollectionWorkOrderList: ['/lt-web/xs/collection/workOrderList'], // 获取用户工单列表
  getCollectionWorkDetailList: ['/lt-web/xs/collection/workDetailList'], // 获取工单详情
  getMarketPageConfig: ['/lt-web/market/getPageConfig'], // 获取资源位模块数据
  getMarketProductByGroupId: ['/lt-web/market/getProductByGroupId'], // 获取资源位模块下的产品列表
  getMarketResources: ['/lt-web/app/getResources'], // 获取资源位模块下的资源
  getAppIsCheck: ['/lt-web/xs/user/appIsCheck'], // 获取App是否在审核中
  checkOverdueStatus: ['/lt-web/user/checkOverdueStatus'], // 获取用户逾期状态
  getPersonalLoanCostDisclosure: ['/lt-web/borrow/personalLoanCostDisclosure']
}

export default main
